import { render } from "./BalancesTable.vue?vue&type=template&id=d4dac314&scoped=true"
import script from "./BalancesTable.vue?vue&type=script&lang=js"
export * from "./BalancesTable.vue?vue&type=script&lang=js"

import "./BalancesTable.vue?vue&type=style&index=0&id=d4dac314&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4dac314"]])

export default __exports__